import { ROLES } from "@lucky-try/shared";
import { z } from "zod";
import { isoDateTime, paginationQuerySchema, queryBoolean } from "./common";

export const roleSchema = z.enum(ROLES);

export const adminUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  emailVerified: z.boolean(),
  role: roleSchema,
  banned: z.boolean(),
  legacyId: z.number().int().nullable(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type AdminUser = z.infer<typeof adminUserSchema>;

export const adminUserListQuerySchema = paginationQuerySchema.extend({
  q: z.string().trim().max(200).optional(),
  role: roleSchema.optional(),
  banned: queryBoolean.optional(),
});

export const adminUserCreateSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.email().max(254),
  role: roleSchema,
  password: z.string().min(12).max(128),
});

export const adminUserUpdateSchema = z
  .object({
    name: z.string().trim().min(1).max(120),
    role: roleSchema,
    banned: z.boolean(),
    emailVerified: z.boolean(),
  })
  .partial();

export const currentUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: roleSchema,
  permissions: z.array(z.string()),
});
export type CurrentUser = z.infer<typeof currentUserSchema>;
